var monitor = "https://shopfront-cdn.tekoapis.com/static/7a92580cceeadb46.svg";

export { monitor as default };
